import { render, staticRenderFns } from "./ThemesEditorNavSearch.vue?vue&type=template&id=20815eaa"
import script from "./ThemesEditorNavSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesEditorNavSearch.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports